import { defineStore } from "pinia";
import {ClientSession, DataboxAPIConfig, UserCredential } from "nmt_databox";

export const useApplicationStore = defineStore('ApplicationStore',{
  //state
  state: () => ({ 
    $USER: new UserCredential,
    $APP_READY: false,
    $SESSION: new ClientSession,
    $DATABOX_CFG: new DataboxAPIConfig('','',''),
  }),

  //action


  //getter
})


